import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getConciergeUrl} from '../../services/getConciergeUrl';

export const useGetConciergeUrlQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.CONCIERGE_URL],
		queryFn: ({signal}) => getConciergeUrl({signal}),
		retry: 1,
		enabled: false,
		staleTime: 0,
	});
